export const FEE = {
  isHidden: true,
  nickname: 'PRODUCTS.FEE.nickname',
  icon:'fee'
};
